<svg
	fill="currentColor"
	xmlns:dc="http://purl.org/dc/elements/1.1/"
	xmlns:cc="http://creativecommons.org/ns#"
	xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
	xmlns:svg="http://www.w3.org/2000/svg"
	xmlns="http://www.w3.org/2000/svg"
	xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
	xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
	version="1.1"
	x="0px"
	y="0px"
	width="32px"
	height="32px"
	viewBox="0 0 32 32"
	enable-background="new 0 0 32 32"
	xml:space="preserve"
	id="svg2"
	inkscape:version="0.48.4 r9939"
	sodipodi:docname="script.svg"
	><defs id="defs3139" /><sodipodi:namedview
		pagecolor="#ffffff"
		bordercolor="#666666"
		borderopacity="1"
		objecttolerance="10"
		gridtolerance="10"
		guidetolerance="10"
		inkscape:pageopacity="0"
		inkscape:pageshadow="2"
		inkscape:window-width="640"
		inkscape:window-height="480"
		id="namedview3137"
		showgrid="false"
		inkscape:zoom="7.375"
		inkscape:cx="16"
		inkscape:cy="16"
		inkscape:window-x="53"
		inkscape:window-y="24"
		inkscape:window-maximized="0"
		inkscape:current-layer="svg2"
	/><metadata id="metadata3127"
		><rdf:RDF
			><cc:Work rdf:about=""
				><dc:format>image/svg+xml</dc:format><dc:type
					rdf:resource="http://purl.org/dc/dcmitype/StillImage"
				/><dc:title>PICOL Icon</dc:title><dc:date>2009-03-15</dc:date
				><dc:creator
					><cc:Agent><dc:title>Melih Bilgil</dc:title></cc:Agent></dc:creator
				><dc:rights
					><cc:Agent><dc:title>Creative Commons BY-SA</dc:title></cc:Agent
					></dc:rights
				><dc:publisher
					><cc:Agent
						><dc:title>PICOL - Pictorial Communication Language</dc:title
						></cc:Agent
					></dc:publisher
				><dc:identifier>http://blog.picol.org</dc:identifier><dc:source
					>http://blog.picol.org</dc:source
				><dc:language>en</dc:language><dc:subject
					><rdf:Bag
						><rdf:li>PICOL</rdf:li><rdf:li>icon</rdf:li><rdf:li>icons</rdf:li
						><rdf:li>sign</rdf:li><rdf:li>GUI</rdf:li><rdf:li>vector</rdf:li
						><rdf:li>interface</rdf:li></rdf:Bag
					></dc:subject
				><dc:description>This is one icon out of all PICOL icons</dc:description
				><dc:contributor
					><cc:Agent
						><dc:title
							>Melih Bilgil (www.lonja.de), Christopher Adjei (www.boffer.net)</dc:title
						></cc:Agent
					></dc:contributor
				><cc:license
					rdf:resource="http://creativecommons.org/licenses/by-sa/3.0/"
				/></cc:Work
			><cc:License rdf:about="http://creativecommons.org/licenses/by-sa/3.0/"
				><cc:permits
					rdf:resource="http://creativecommons.org/ns#Reproduction"
				/><cc:permits
					rdf:resource="http://creativecommons.org/ns#Distribution"
				/><cc:requires
					rdf:resource="http://creativecommons.org/ns#Notice"
				/><cc:requires
					rdf:resource="http://creativecommons.org/ns#Attribution"
				/><cc:permits
					rdf:resource="http://creativecommons.org/ns#DerivativeWorks"
				/><cc:requires
					rdf:resource="http://creativecommons.org/ns#ShareAlike"
				/></cc:License
			></rdf:RDF
		></metadata
	><g id="background"
		><rect fill="none" width="32" height="32" id="rect3130" /></g
	><path
		id="path3135"
		d="M 3.382,31.999 4.105,30.554 C 4.101,30.549 4.573,29.62 5.05,28.183 l 0,0 C 5.532,26.747 6.002,24.834 6,23 l 0,0 C 6.017,21.321 5.079,18.86 4.07,16.371 l 0,0 C 3.08,13.86 2.017,11.322 2,8.999 l 0,0 C 2.015,4.68 4.083,0.622 4.105,0.552 l 0,0 L 4.381,0 h 24.234 l -0.723,1.446 c 0.004,0.004 -0.466,0.933 -0.946,2.369 l 0,0 C 26.467,5.253 25.997,7.167 25.999,9 l 0,0 c -0.017,1.679 0.921,4.14 1.928,6.63 l 0,0 c 0.993,2.509 2.056,5.048 2.072,7.371 l 0,0 c -0.017,4.319 -2.082,8.377 -2.106,8.445 l 0,0 L 27.617,32 H 3.382 l 0,-0.001 z m 22.973,-2 c 0.181,-0.414 0.437,-1.041 0.694,-1.816 l 0,0 C 27.53,26.747 28,24.834 27.998,23 l 0,0 c 0.017,-1.679 -0.921,-4.14 -1.928,-6.629 l 0,0 C 25.078,13.86 24.014,11.323 23.998,8.999 l 0,0 C 24.01,6.232 24.861,3.573 25.479,2 l 0,0 H 5.642 C 5.462,2.414 5.206,3.041 4.947,3.814 l 0,0 C 4.468,5.252 3.998,7.166 4,8.999 l 0,0 c -0.019,1.679 0.921,4.14 1.928,6.63 l 0,0 C 6.921,18.138 7.981,20.677 8,23 l 0,0 c -0.011,2.768 -0.862,5.427 -1.479,6.999 l 0,0 h 19.834 l 0,0 z"
	/></svg
>
